import React, { useState, useEffect, useRef } from 'react';
import logo from "../images/icons/logo.svg"
import { Link } from 'react-router-dom';
import nigeria from '../images/icons/nigeria.svg'
import sa from '../images/icons/sa.svg'
import drop from '../images/icons/dropdown.svg'
import axios from 'axios'

function Header(props) {
    const [isMenu, setIsMenu] = useState(0)
    const [country, setCountry] = useState(sessionStorage.getItem('userCountry') || '');
      useEffect(() => {
    if (!country) {
      fetch('https://ipinfo.io/json?token=98b21ec2ff9bf7')
        .then(res => res.json())
        .then(data => {
          const userCountry = data.country == 'ZA' ? 'South Africa' : 'Nigeria';
          setCountry(userCountry);
          sessionStorage.setItem('userCountry', userCountry);
        })
        .catch(err => {
          console.error('Failed to fetch country:', err);
        });
    }
  }, [country]);
     
  async function filterBusinesses(country) {
        await sessionStorage.setItem('userCountry',country)
        window.location.reload()
    }
    const [showFilter, setShowFilter] = useState(false)
    const filterRef = useRef(null)
    useEffect(() => {
        if (!showFilter) return
        const close = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target)) setShowFilter(false)
        }
        const onKey = (event) => {
            if (event.key === 'Escape') setShowFilter(false)
        }
        document.addEventListener('mousedown', close)
        document.addEventListener('keydown', onKey)
        return () => {
            document.removeEventListener('mousedown', close)
            document.removeEventListener('keydown', onKey)
        }
    }, [showFilter])
    const navClass = 'rounded-full px-3 py-2 transition hover:bg-[#F4F4F4] hover:text-[#008B39]'
    return (
        <div className='border-b-[1px]  p-5 px-5 lg:px-20'>
        <div className='flex flex-row justify-between items-center'>
            <a href='/'><img src={logo} /></a>
            <div className='hidden lg:flex'>
                <ul className='flex flex-col lg:flex-row lg:space-x-4'>
                    <li><Link className={navClass} to='/'>Home</Link></li>
                    <li><Link className={navClass} to='/about'>About Us</Link></li>
                    <li><Link className={navClass} to='/pricing'>Pricing</Link></li>
                    <li><Link className={navClass} to='/faqs'>FAQs</Link></li>
                    <li><Link className={navClass} to='/contact'>Contact Us</Link></li>
                    <li><Link className={navClass} to='/blogs'>Blogs</Link></li>
                </ul>
            </div>
            <div className=' hidden lg:flex flex-row space-x-4 items-center'>
                <div className='relative' ref={filterRef}>
                    <button type="button" aria-expanded={showFilter} aria-label="Choose country" onClick={() => setShowFilter(!showFilter)} className='relative flex h-[40px] flex-row items-center space-x-2 rounded-[24px] bg-[#F4F4F4] px-3 transition hover:bg-[#EAEAEA]'>
                        <span><img src={country == 'Nigeria' ? nigeria : sa} alt="" /></span>
                        <span className='text-[12px]'>{country}</span>
                        <span><img src={drop} alt="" /></span>
                    </button>
                    {showFilter ? <div className='absolute z-50 mt-2 flex w-[215px] flex-col rounded-[8px] bg-white py-2 pl-2 text-[#242424] shadow-lg'>
                            <div onClick={() => filterBusinesses('Nigeria')} className='flex flex-row space-x-6 cursor-pointer hover:bg-gray-200 px-2 py-2 pb-1 rounded-t-[8px]'>
                                <span className=''><img src={nigeria} /></span>
                                <span>Nigeria</span>
                            </div>
                            <div onClick={() => filterBusinesses('South Africa')} className='flex flex-row space-x-6 cursor-pointer hover:bg-gray-200 px-2 py-2 pt-1 rounded-b-[8px]'>
                                <span className=''><img src={sa} /></span>
                                <span>South Africa</span>
                            </div>
                    </div> : ''}
                </div>
                
                <span><a className="rounded-full px-3 py-2 transition hover:text-[#008B39]" href='https://portal.yebokenny.com'>Login</a></span>
                <a href='https://portal.yebokenny.com/register' className='grid h-[47px] rounded-[30px] bg-[#008B39] px-7 text-white transition hover:bg-[#0C6F35] active:scale-[0.98]'>
                    <span className='my-auto'>Sign Up</span>
                </a>
                {/* <span><a href='https://yeboportal.web.app'>Login</a></span>
                <a href='https://yeboportal.web.app/register' className='rounded-[30px] bg-[#008B39] text-white h-[47px] px-7 grid'>
                    <span className='my-auto'>Sign Up</span>
                </a> */}
            </div>
            <button type="button" aria-label={isMenu ? 'Close menu' : 'Open menu'} aria-expanded={!!isMenu} onClick={() => setIsMenu(!isMenu)} className='grid cursor-pointer flex-col items-center space-y-[1px] bg-[#008B39] p-2 text-black hover:bg-[#0C6F35] lg:hidden'>
                <hr className='h-1 w-4 my-auto'/>
                <hr className='h-1 w-4 my-auto'/>
                <hr className='h-1 w-4 my-auto'/>
            </button>
        </div>
        {isMenu ?
        <div className='lg:hidden'>
            <div>
                <ul className='flex flex-col space-y-1'>
                    <li><Link className="block rounded-xl px-2 py-2 transition hover:bg-[#F4F4F4] hover:text-[#008B39]" to='/'>Home</Link></li>
                    <li><Link className="block rounded-xl px-2 py-2 transition hover:bg-[#F4F4F4] hover:text-[#008B39]" to='/about'>About Us</Link></li>
                    <li><Link className="block rounded-xl px-2 py-2 transition hover:bg-[#F4F4F4] hover:text-[#008B39]" to='/pricing'>Pricing</Link></li>
                    <li><Link className="block rounded-xl px-2 py-2 transition hover:bg-[#F4F4F4] hover:text-[#008B39]" to='/faqs'>FAQs</Link></li>
                    <li><Link className="block rounded-xl px-2 py-2 transition hover:bg-[#F4F4F4] hover:text-[#008B39]" to='/contact'>Contact Us</Link></li>
                    <li><Link className="block rounded-xl px-2 py-2 transition hover:bg-[#F4F4F4] hover:text-[#008B39]" to='/blogs'>Blog</Link></li>
                </ul>
            </div>
            <div className='flex flex-col items-center mt-2 space-y-2'>
                <a href='https://portal.yebokenny.com'>Login</a>
                <a href='https://portal.yebokenny.com/register' className='grid h-[47px] rounded-[30px] bg-[#008B39] px-7 text-white transition hover:bg-[#0C6F35]'>
                    <span className='my-auto'>Sign Up</span>
                </a>
                {/* <a href='https://yeboportal.web.app/'>Login</a>
                <a href='https://yeboportal.web.app/register' className='rounded-[30px] bg-[#008B39] text-white h-[47px] px-7 grid'>
                    <span className='my-auto'>Sign Up</span>
                </a> */}
            </div>
        </div>
        : null}
        </div>
    );
}

export default Header;